import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Leaderboard from "../interfaces/leaderboard";
import { ASSETS_URL } from "../util/constants";

interface LeaderboardListItemProps {
  player: Leaderboard;
  rank: number;
  categoryName: string;
}

const LeaderboardListItem = ({
  player,
  rank,
  categoryName,
}: LeaderboardListItemProps) => {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);
  const defaultAvatar = `${ASSETS_URL}/avatar/collector.png`;
  const rankClass = rank <= 3 ? `rank-${rank}` : "";
  const teamClass =
    player.user.pokemonGoProfile?.team?.name?.toLowerCase() || "harmony";
  const avatarUrl = player.user.pokemonGoProfile?.urlImage || defaultAvatar;
  const isTotalView = categoryName && (categoryName.startsWith("Total_") || categoryName === "Overall");
  const getMedalImageUrl = (pathImage: string) => {
    if (!pathImage) return "";
    const cleanPath = pathImage.replace(/^\.\//, "");
    return `${ASSETS_URL}/${cleanPath}_Shadow.png`;
  };

  const handleRowClick = (e: React.MouseEvent) => {
    if (isTotalView) {
      e.preventDefault();
      setIsExpanded(!isExpanded);
    }
  };

  return (
    <div className={`leaderboard-item-wrapper ${isExpanded ? "expanded" : ""}`}>
      <Link
        to={`/profile/${player.user.username}`}
        className={`preview-entry ${rankClass}`}
        onClick={handleRowClick}
      >
        <div className={`team-decal ${teamClass}`}></div>
        <span className="rank">#{rank}</span>
        <img src={avatarUrl} alt="Avatar" className="avatar" />

        <div className="player-info">
          <span className="player-name">{player.user.username}</span>
          <div className="player-details">
            <span className="player-level">
              Level {player.user.pokemonGoProfile?.level || "N/A"}
            </span>
            {isTotalView && (
              <span className="dropdown-arrow">{isExpanded ? "▲" : "▼"}</span>
            )}
          </div>
        </div>

        <div className="player-stats">
          <span className="xp">{player.userMedal.quantity.toFixed(2)} pts</span>
          <span className="medals">
            {isTotalView ? "Total points" : categoryName}
          </span>
        </div>
      </Link>
      {isTotalView && isExpanded && (
        <div className="dropdown-content">
          <button
            className="btn-go-profile"
            onClick={() => navigate(`/profile/${player.user.username}`)}
          >
            View profile
          </button>

          <div className="medals-breakdown list-view">
            {player.breakdown?.map((medal) => (
              <div key={medal.medalName} className="breakdown-list-item">
                <div className="breakdown-item-info">
                  <img
                    src={getMedalImageUrl(medal.pathImage)}
                    alt={medal.medalName}
                  />
                  <span>{medal.medalName}</span>
                </div>
                <span className="breakdown-item-value">{medal.quantity}</span>
              </div>
            ))}
            {(!player.breakdown || player.breakdown.length === 0) && (
              <span className="no-medals-text">
                Nenhuma medalha registrada nesta categoria.
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default LeaderboardListItem;
